export default __webpack_public_path__ + "static/qrcode-wechat-bf44e3ecb0265fc9d4e1f93cd1839968.jpeg";